export function reportsJson (language) {
  let items

  if (language === 'es') {
    items = {
      lastLocationReport: {
        name: 'lastLocationReport',
        label: 'reporte de últimas ubicaciones de los dispositivos'
      },
      reportedDevicesReport: {
        name: 'reportedDevicesReport',
        label: 'reporte de dispositivos denunciados'
      },
      missingDevicesReport: {
        name: 'missingDevicesReport',
        label: 'reporte de dispositivos faltantes'
      },
      deviceHardwareReport: {
        name: 'deviceHardwareReport',
        label: 'reporte de hardware de los dispositivos'
      },
      // deviceApplicationsReport: {
      //   name: 'deviceApplicationsReport',
      //   label: 'reporte de aplicaciones de los dispositivos'
      // },
      devicesReport: {
        name: 'devicesReport',
        label: 'reporte de los dispositivos'
      },
      deviceActivationReport: {
        name: 'deviceActivationReport',
        label: 'reporte de activación de dispositivos'
      },
      usersReport: {
        name: 'usersReport',
        label: 'reporte de los usuarios'
      },
      geofencesReport: {
        name: 'geofencesReport',
        label: 'reporte de las geocercas'
      },
      appsReport: {
        name: 'appsReport',
        label: 'reporte de las aplicaciones'
      },
      exportPdfInReport: {
        name: 'exportPdfInReport',
        label: 'exportar reportes en formato pdf'
      },
      exportCsvInReport: {
        name: 'exportCsvInReport',
        label: 'exportar reportes en formato csv'
      }
    }
  } else if (language === 'en') {
    items = {
      lastLocationReport: {
        name: 'lastLocationReport',
        label: 'report of last device locations'
      },
      reportedDevicesReport: {
        name: 'reportedDevicesReport',
        label: 'report of reported devices'
      },
      missingDevicesReport: {
        name: 'missingDevicesReport',
        label: 'missing device report'
      },
      deviceHardwareReport: {
        name: 'deviceHardwareReport',
        label: 'hardware report of the devices'
      },
      // deviceApplicationsReport: {
      //   name: 'deviceApplicationsReport',
      //   label: 'device apps report'
      // },
      devicesReport: {
        name: 'devicesReport',
        label: 'device report'
      },
      deviceActivationReport: {
        name: 'deviceActivationReport',
        label: 'device activation report'
      },
      usersReport: {
        name: 'usersReport',
        label: 'user report'
      },
      geofencesReport: {
        name: 'geofencesReport',
        label: 'geofence report'
      },
      appsReport: {
        name: 'appsReport',
        label: 'application report'
      },
      exportPdfInReport: {
        name: 'exportPdfInReport',
        label: 'export reports in PDF format'
      },
      exportCsvInReport: {
        name: 'exportCsvInReport',
        label: 'export reports in CSV format'
      }
    }
  }
  return (items)
}
